export const CAPTCHA_CHECKBOX_ID = 'captcha'
